import { Link } from "react-router-dom"
import { SvgClose, SvgQuestionMark } from "../SVG/svg"
import { ExternalServiceNow, InternalServiceNow, USERGROUP, useAuth, isUserOfType } from "../../provider/authprovider";

const ThemeFooter = () => {
    const { userDetails } = useAuth();

 

    return (
        <>
            {/* <div className="container footer">
                <h2>Related Links</h2>
                <ul className="footer-top-list">
                    <li>
                        <div>
                            <a href="https://bes.sit.welllink.bakerhughes.com/BES/login" target="_blank" rel="noreferrer">
                                <strong>BEACON Entitlements System 1.0</strong>
                            </a>
                        </div>
                        The BEACON Entitlements 1.0 System is used to submit a service request for WellLink Data Services & WellLink Wireline
                    </li>
                    <li>
                        <div>
                            <a href="https://bhge-ofse-dev.saviyntcloud.com/ECMv6/request/requestHome" target="_blank" rel="noreferrer">
                                <strong>BEACON Entitlements System 2.0</strong>
                            </a>
                        </div>
                        The BEACON Entitlements System 2.0 is used to submit user access for WellLink RT
                    </li>
                    <li>
                        <div>
                            <a href="http://servicecatalog.ent.bhicorp.com/usm/wpf?Node=icguinode.cataloggetchildren&Args=13144&ObjectID=13144&NspPath=" target="_blank" rel="noreferrer">
                                <strong>ProductionLink or WellLink Solutions Access</strong>
                            </a>
                        </div>
                        Service Catalog may be used to submit a service request for ProductionLink, WellLink Performance or WellLink Assurance
                    </li>
                    <li>
                        <div><Link to="/beacon-admin-1"><strong>BEACON Administration 1.0</strong></Link></div>
                        Links to tools (user push & RT fail over) for BEACON Admin teams
                    </li>
                    <li>
                        <div><Link to="/beacon-admin-2"><strong>BEACON Admin App 2.0</strong></Link></div>
                        The BEACON Admin App 2.0 is used by internal admins to manage Assets, Usergroups, Featureset and Application centrally.
                    </li>
                    <li>
                        <div><Link to="/test-app"><strong>Test Applicaitons</strong></Link></div>
                        Links for BEACON test environments.
                    </li>
                </ul>
            </div> */}
            <div className="container footer-disclaimer">
                By using Kantori™ or ProductionLink™ services, you agree to comply with all the applicable laws, regulations and other requirements including but not limited to those pertaining to data privacy and security and the storage, processing, communication and disclosure of hydrocarbon data, whether in Country or cross-border.
            </div>
            <div className="footer-bottom">
                <p style={{ margin: 0, padding: "0 20px" }}>@ 2026 Baker Hughes Company</p>
                <p style={{ margin: 0 }}>
                    <a href="https://www.bakerhughes.com/terms" target="_blank" rel="noreferrer">Terms</a>
                    <a href="https://www.bakerhughes.com/privacy" target="_blank" rel="noreferrer">Privacy Notice</a>
                </p>
            </div >
            <div className="float-footer-helper">
                <div className="float-footer-icon">
                    <div className="message-icon">
                        <SvgQuestionMark />
                    </div>
                    <div className="close-icon">
                        <SvgClose />
                    </div>
                </div>
                <div className="float-footer-helper-list">
                    <ul>
                        <li><strong className="primary-color">24/7 Support</strong></li>
                        <li><strong>BEACON Americas:</strong></li>
                        <li>1-866-623-2266</li>
                        <li>(+1) 713-879-4000</li>
                        <li><strong>BEACON Europe:</strong></li>
                        <li>(+44) 1224-720098</li>
                        <li><strong>BEACON Asia:</strong></li>
                        <li>(+603) 27303188</li>
                        <li><strong>Email:</strong></li>
                        <li><Link to="mailto:beacon@bakerhughes.com">beacon@bakerhughes.com</Link></li>
                        <hr style={{ margin: "15px 0" }} />
                        <li><strong className="primary-color">Need Help?</strong></li>
                        {
                            (isUserOfType(userDetails.userGroup,USERGROUP.INTERNAL)) ?
                                <li>Enhance your knowledge, Submit a case, or for Chat support,
                                    <a href={InternalServiceNow} target="_blank" rel="noreferrer">
                                        <strong> click here</strong>
                                    </a>
                                </li> :
                                <li>Enhance your knowledge, Submit a case, or for Chat support,
                                    <a href={ExternalServiceNow} target="_blank" rel="noreferrer">
                                        <strong> click here</strong>
                                    </a>
                                </li>
                        }
                        {/*
                        <li style={{ paddingTop: "10px" }}><strong className="primary-color">Security Preferences</strong></li>
                        <li>
                            If you have not set your security preferences,
                            <a href="https://bakerhughes.service-now.com/csm" target="_blank" rel="noreferrer"><strong> click here</strong></a>
                        </li>
                        */}
                    </ul>
                </div>
            </div>
        </>
    )
}

export default ThemeFooter
